// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"dfdb0d71","455":"60e160d3","578":"412d4429","857":"453c531f","977":"c374cd8f"}[chunkId] + ".chunk.js";
};